import { render, staticRenderFns } from "./AddRemovePropertyLine.vue?vue&type=template&id=4d4fd3b4&scoped=true"
import script from "./AddRemovePropertyLine.vue?vue&type=script&lang=ts"
export * from "./AddRemovePropertyLine.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4fd3b4",
  null
  
)

export default component.exports